import __ from "standard/dunder";

const onInvalid = (target, propertyKey) => {
  const onInvalidCallback = target[__.onInvalid__] ?? (() => undefined);

  Reflect.defineProperty(target, __.onInvalid__, {
    value() {
      Reflect.apply(onInvalidCallback, this, arguments);
      return this[propertyKey](...arguments);
    },
    writable: true,
  });
};

export default onInvalid;
